import { FixedActionSidebar } from "./FixedActionSidebar";
import { FixedThinSidebar } from "./FixedThinSidebar";
import { LeftSidebar } from "./LeftSidebar";

export const FixedLeftSidebar = Object.assign(LeftSidebar, {
  FixedThinSidebar,
  FixedActionSidebar,
});
